import { useRef } from 'react';
import ReactEcharts from 'echarts-for-react';
import { useTranslation } from 'react-i18next';

import { useGroupStatusSummary } from '../../modules/organisation/hooks/useGroupStats';
import HomeCard from './HomeCard';
import { getChartLabelColor } from '../lib/utils';
import useElementWidth from '../../hooks/useElementWidth';

const LG_BREAKDOWN = 620;
const SM_BREAKDOWN = 410;

// Device status chart for FitMachine.
function DeviceStatus() {
  const { t } = useTranslation();
  const statusSummary = useGroupStatusSummary();
  const cardRef = useRef(null);
  const width = useElementWidth(cardRef.current);

  const chartOptions = {
    legend: width <= SM_BREAKDOWN ? {
      orient: 'horizontal',
      left: 'center',
      top: 'bottom',
      textStyle: {
        fontSize: 10,
      }
    }: {
      orient: 'vertical',
      left: 'left',
      top: 'top',
      textStyle: {
        fontSize: 12,
      }
    },
    center:
      width >= LG_BREAKDOWN ? ['50%', '50%'] :
        width <= SM_BREAKDOWN ? ['50%', '35%'] :
          ['66%', '50%'],
    radius: width <= SM_BREAKDOWN ? ['25%', '60%'] : ['30%', '70%']
  };

  if(!statusSummary) return null;

  const { items = [], _state_: {loading, error} = {} } = statusSummary || {};

  return (
    <div ref={cardRef}>
      <HomeCard
        header={t("user.FitMachine_Status")}
        headerLink={{ to: '/devices/admin', text: t('user.All_FitMachines') }}
        loading={loading}
        error={error}
      >
        <ReactEcharts
          option={{
            tooltip: {
              formatter: params => `${t(params.data.name)}: ${params.percent}%`
            },
            legend: {
              ...chartOptions.legend,
              data: items.map(item => item.key),
              formatter: item => t(item),
            },
            series: {
              name: 'user.FitMachine_Status',
              type: 'pie',
              radius: chartOptions.radius,
              center: chartOptions.center,
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: false,
                  position: 'center'
                }
              },
              color: items.map(item => getChartLabelColor(item.color)),
              data: items.map(item => ({
                value: item.count,
                name: item.key,
              })),
            }
          }}
        />
      </HomeCard>
    </div>
  );
}

export default DeviceStatus;